import axios from "axios";

const authFetch = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

authFetch.interceptors.request.use(
  function (req) {
    const token = localStorage.getItem("token");
    if (token) {
      req.headers.authorization = `Bearer ${token}`;
      return req;
    }
    return req;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default authFetch;
